import * as React from 'react';
import { BaseComponent } from '../../BaseComponent';
import { DragType } from './FloorPlanSubPage';

export enum FloorPlanInteractorType {
    TOP_LEFT = 1,
    TOP_RIGHT = 2,
    TOP = 3,
    LEFT = 4,
    RIGHT = 5,
    BOTTOM = 6,
    BOTTOM_LEFT = 7,
    BOTTOM_RIGHT = 8
}

interface FloorPlanInteractorProps {
    type: FloorPlanInteractorType;
}

interface FloorPlanInteractorState {
    valid: boolean;
    turned: boolean;

    display: string;
    pointerEvents: React.CSSProperties['pointerEvents'];
    top: string;
    left: string;
    bottom: string;
    right: string;
    width: string;
    height: string;
    classOverride: string;
}

export class FloorPlanInteractor extends BaseComponent<FloorPlanInteractorProps, FloorPlanInteractorState> {
    public componentWillMount(): void {
        this.setState({
            valid: true,
            turned: false,
            display: 'block',
            pointerEvents: 'auto',
            top: '0',
            left: '0',
            bottom: '0',
            right: '0',
            width: '0',
            height: '0',
            classOverride: ''
        });
    }

    public render(): JSX.Element | null {
        switch (this.props.type) {
            case FloorPlanInteractorType.TOP_LEFT:
            case FloorPlanInteractorType.TOP_RIGHT:
            case FloorPlanInteractorType.TOP:
            case FloorPlanInteractorType.LEFT:
            case FloorPlanInteractorType.RIGHT:
            case FloorPlanInteractorType.BOTTOM:
            case FloorPlanInteractorType.BOTTOM_LEFT:
            case FloorPlanInteractorType.BOTTOM_RIGHT:
                return (
                    <div
                        className={this.className()}
                        id={this.id()}
                        style={this.style()}
                    />
                );
            default:
                return null;
        }
    }

    public update(width: number, height: number, sizeH: number, sizeV: number, validSize: boolean, store: any, draggingIndex: DragType | null): void {
        const state: FloorPlanInteractorState = {...this.state};
        switch (this.props.type) {
            case FloorPlanInteractorType.TOP:
                if (width < 3 * 40 - 5) {
                    state.display = 'none';
                } else {
                    state.display = 'block';
                    state.left = (Math.round(Math.min(store.cropPosition.x1, store.cropPosition.x2) - sizeH + .5 * width)).toString() + 'px';
                    state.top = (Math.round(store.cropPosition.y1 - sizeV)).toString() + 'px';
                    state.width = (2 * sizeH).toString() + 'px';
                    state.height = (2 * sizeV).toString() + 'px';
                    state.turned = (store.cropPosition.y1 > store.cropPosition.y2);
                }
                break;
            case FloorPlanInteractorType.BOTTOM:
                if (width < 3 * 40 - 5) {
                    state.display = 'none';
                } else {
                    state.display = 'block';
                    state.left = (Math.round(Math.min(store.cropPosition.x1, store.cropPosition.x2) - sizeH + .5 * width)).toString() + 'px';
                    state.top = (Math.round(store.cropPosition.y2 - sizeV)).toString() + 'px';
                    state.width = (2 * sizeH).toString() + 'px';
                    state.height = (2 * sizeV).toString() + 'px';
                    state.turned = (store.cropPosition.y1 > store.cropPosition.y2);
                }
                break;
            case FloorPlanInteractorType.LEFT:
                if (height < 3 * 40 - 5) {
                    state.display = 'none';
                } else {
                    state.display = 'block';
                    state.left = (Math.round(store.cropPosition.x1 - sizeH)).toString() + 'px';
                    state.top = (Math.round(Math.min(store.cropPosition.y1, store.cropPosition.y2) - sizeV + .5 * height)).toString() + 'px';
                    state.width = (2 * sizeH).toString() + 'px';
                    state.height = (2 * sizeV).toString() + 'px';
                    state.turned = (store.cropPosition.x1 > store.cropPosition.x2);
                }
                break;
            case FloorPlanInteractorType.RIGHT:
                if (height < 3 * 40 - 5) {
                    state.display = 'none';
                } else {
                    state.display = 'block';
                    state.left = (Math.round(store.cropPosition.x2 - sizeH)).toString() + 'px';
                    state.top = (Math.round(Math.min(store.cropPosition.y1, store.cropPosition.y2) - sizeV + .5 * height)).toString() + 'px';
                    state.width = (2 * sizeH).toString() + 'px';
                    state.height = (2 * sizeV).toString() + 'px';
                    state.turned = (store.cropPosition.x1 > store.cropPosition.x2);
                }
                break;
            case FloorPlanInteractorType.TOP_LEFT:
                state.left = (Math.round(store.cropPosition.x1 - sizeH)).toString() + 'px';
                state.top = (Math.round(store.cropPosition.y1 - sizeV)).toString() + 'px';
                state.width = (2 * sizeH).toString() + 'px';
                state.height = (2 * sizeV).toString() + 'px';
                state.classOverride = (
                    (store.cropPosition.y1 > store.cropPosition.y2 ? 'bottom' : 'top') +
                    '-' +
                    (store.cropPosition.x1 > store.cropPosition.x2 ? 'right' : 'left') +
                    '-interactor'
                );
                break;
            case FloorPlanInteractorType.TOP_RIGHT:
                state.left = (Math.round(store.cropPosition.x2 - sizeH)).toString() + 'px';
                state.top = (Math.round(store.cropPosition.y1 - sizeV)).toString() + 'px';
                state.width = (2 * sizeH).toString() + 'px';
                state.height = (2 * sizeV).toString() + 'px';
                state.classOverride = (
                    (store.cropPosition.y1 > store.cropPosition.y2 ? 'bottom' : 'top') +
                    '-' +
                    (store.cropPosition.x1 > store.cropPosition.x2 ? 'left' : 'right') +
                    '-interactor'
                );
                break;
            case FloorPlanInteractorType.BOTTOM_LEFT:
                state.left = (Math.round(store.cropPosition.x1 - sizeH)).toString() + 'px';
                state.top = (Math.round(store.cropPosition.y2 - sizeV)).toString() + 'px';
                state.width = (2 * sizeH).toString() + 'px';
                state.height = (2 * sizeV).toString() + 'px';
                state.classOverride = (
                    (store.cropPosition.y1 > store.cropPosition.y2 ? 'top' : 'bottom') +
                    '-' +
                    (store.cropPosition.x1 > store.cropPosition.x2 ? 'right' : 'left') +
                    '-interactor'
                );
                break;
            case FloorPlanInteractorType.BOTTOM_RIGHT:
                state.left = (Math.round(store.cropPosition.x2 - sizeH)).toString() + 'px';
                state.top = (Math.round(store.cropPosition.y2 - sizeV)).toString() + 'px';
                state.width = (2 * sizeH).toString() + 'px';
                state.height = (2 * sizeV).toString() + 'px';
                state.classOverride = (
                    (store.cropPosition.y1 > store.cropPosition.y2 ? 'top' : 'bottom') +
                    '-' +
                    (store.cropPosition.x1 > store.cropPosition.x2 ? 'left' : 'right') +
                    '-interactor'
                );
                break;
            default:
                break;
        }
        if (state.display === 'block') {
            state.pointerEvents = ((draggingIndex === DragType.IMAGE || draggingIndex === DragType.ZOOM) ? 'none' : 'auto');
        }
        state.valid = validSize;
        this.setState(state);
    }

    protected id = (turned?: boolean): string => {
        switch (this.props.type) {
            case FloorPlanInteractorType.TOP_LEFT:
                return 'top-left-interactor';
            case FloorPlanInteractorType.TOP_RIGHT:
                return 'top-right-interactor';
            case FloorPlanInteractorType.TOP:
                if (turned) {
                    return 'bottom-interactor';
                }
                return 'top-interactor';
            case FloorPlanInteractorType.LEFT:
                return 'left-interactor';
            case FloorPlanInteractorType.RIGHT:
                return 'right-interactor';
            case FloorPlanInteractorType.BOTTOM:
                if (turned) {
                    return 'top-interactor';
                }
                return 'bottom-interactor';
            case FloorPlanInteractorType.BOTTOM_LEFT:
                return 'bottom-left-interactor';
            case FloorPlanInteractorType.BOTTOM_RIGHT:
                return 'bottom-right-interactor';
            default:
                return 'unnamed-interactor';
        }
    };

    protected className(): string {
        const result: Array<string> = ['interactor'];
        result.push(this.state.classOverride ? this.state.classOverride : this.id(this.state.turned));
        if (!this.state.valid) {
            result.push('invalid-interactor');
        }
        return result.join(' ');
    }

    protected style = (): React.CSSProperties => {
        const result: React.CSSProperties = {};
        if (this.state.display != null) { result.display = this.state.display; }
        if (this.state.pointerEvents != null) { result.pointerEvents = this.state.pointerEvents; }
        if (this.state.top != null) { result.top = this.state.top; }
        if (this.state.left != null) { result.left = this.state.left; }
        if (this.state.bottom != null) { result.bottom = this.state.bottom; }
        if (this.state.right != null) { result.right = this.state.right; }
        if (this.state.width != null) { result.width = this.state.width; }
        if (this.state.height != null) { result.height = this.state.height; }
        return result;
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/overlay/floorplan/FloorPlanInteractor.tsx